module.exports = __webpack_public_path__ + "img/scorestar.be230da9.svg";